import { GrantApplication } from "@/api/applicationQueries"

interface OrganizationDetailsProps {
    application: GrantApplication
    userEmail: string
    userName: string
    isOwnershipTransferRequestPending?: boolean
}

export function OrganizationDetails({
    application,
    userEmail,
    userName,
}: OrganizationDetailsProps) {
    return (
        <section className="bg-gray-100 border border-input flex flex-col gap-2 rounded-md p-3 md:p-4">
            <div>
                <h2 className="text-lg font-semibold">Organisation Details</h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                <div className="flex flex-col">
                    <h3 className="font-bold">Charity Number</h3>
                    <p className="text-sm break-words">
                        {application.charityNumber}
                    </p>
                </div>
                <div className="flex flex-col">
                    <h3 className="font-bold">Name</h3>
                    <a
                        href={application.orgURL || ""}
                        target="_blank"
                        rel="noreferrer"
                        className="text-app-defaultLight capitalize underline text-sm break-words"
                    >
                        {application.orgName}
                    </a>
                </div>
                <div className="flex flex-col">
                    <h3 className="font-bold">Country and Region</h3>
                    <p className="capitalize text-sm break-words">
                        {application.country}, {application.region}
                    </p>
                </div>
                <div className="flex flex-col">
                    <h3 className="font-bold">Contact Details</h3>
                    <p className="text-sm break-words">{userName}</p>
                    <a
                        className="text-sm underline text-app-defaultLight break-words"
                        href={`mailto:${userEmail}`}
                    >
                        {userEmail}
                    </a>
                </div>
            </div>
        </section>
    )
}
